import { render, staticRenderFns } from "./ContactWithChildOrder.vue?vue&type=template&id=08dc1af3"
import script from "./ContactWithChildOrder.vue?vue&type=script&lang=ts"
export * from "./ContactWithChildOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports